// extracted by mini-css-extract-plugin
module.exports = {"TeacherInfo":"T1k8hpEy8Yur081CS4k10"};